import { getTheme } from 'ecx.saigon.ui.common';

export function theme(state) {
  return () => getTheme(state.user.entity);
}
